import 'cfg/axios';
import 'vue3-ladda/dist/vue-ladda.css';

import '@fortawesome/fontawesome-free/css/all.min.css';

import Faq              from './Components/Faq/Faq';
import Quiz             from './Components/Quiz/Quiz';
import Auth             from './Components/Auth/Auth';
import Contact          from './Components/Contact/Contact';
import Careers          from './Components/Careers/Careers';
import TrafficInventory from './Components/TrafficInventory/TrafficInventory';

const Mondiad = window.Mondiad || {};

Mondiad.Faq              = Faq;
Mondiad.Quiz             = Quiz;
Mondiad.Auth             = Auth;
Mondiad.Contact          = Contact;
Mondiad.Careers          = Careers;
Mondiad.TrafficInventory = TrafficInventory;

window.Mondiad = Mondiad;
